
export enum SystemTableErrorType {
    NO_DATA = 'NO_DATA',
    INVALID_DATA = 'INVALID_DATA',
    UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
    MISSING_PROPERTIES = 'MISSING_PROPERTIES',
}

export class SystemTableError extends Error {

    constructor(systemTableErrorType: SystemTableErrorType, message: string) {
        
        super(message);
        this.name = 'SystemTableError - ' + systemTableErrorType;
    }
}